"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginCallbackAsync = exports.defaultLoginAsync = void 0;
const crypto_js_1 = require("./crypto.js");
const events_js_1 = require("./events.js");
const initSession_js_1 = require("./initSession.js");
const initWorker_js_1 = require("./initWorker.js");
const parseTokens_js_1 = require("./parseTokens.js");
const requests_js_1 = require("./requests.js");
const route_utils_js_1 = require("./route-utils.js");
// eslint-disable-next-line @typescript-eslint/ban-types
const defaultLoginAsync = (window, configurationName, configuration, publishEvent, initAsync) => (callbackPath = undefined, extras = null, isSilentSignin = false, scope = undefined) => {
    const originExtras = extras;
    extras = Object.assign({}, extras);
    const loginLocalAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const location = window.location;
        const url = callbackPath || location.pathname + (location.search || '') + (location.hash || '');
        if (!('state' in extras)) {
            extras.state = (0, crypto_js_1.generateRandom)(16);
        }
        publishEvent(events_js_1.eventNames.loginAsync_begin, {});
        if (extras) {
            for (const key of Object.keys(extras)) {
                if (key.endsWith(':token_request')) {
                    delete extras[key];
                }
            }
        }
        try {
            const redirectUri = isSilentSignin ? configuration.silent_redirect_uri : configuration.redirect_uri;
            if (!scope) {
                scope = configuration.scope;
            }
            const extraFinal = !configuration.extras ? extras : Object.assign(Object.assign({}, configuration.extras), extras);
            if (!extraFinal.nonce) {
                extraFinal.nonce = (0, crypto_js_1.generateRandom)(12);
            }
            const nonce = { nonce: extraFinal.nonce };
            const serviceWorker = yield (0, initWorker_js_1.initWorkerAsync)(configuration.service_worker_relative_url, configurationName);
            const oidcServerConfiguration = yield initAsync(configuration.authority, configuration.authority_configuration);
            let storage;
            if (serviceWorker) {
                serviceWorker.setLoginParams(configurationName, { callbackPath: url, extras: originExtras });
                serviceWorker.startKeepAliveServiceWorker();
                yield serviceWorker.initAsync(oidcServerConfiguration, 'loginAsync', configuration);
                yield serviceWorker.setNonceAsync(nonce);
                storage = serviceWorker;
            }
            else {
                const session = (0, initSession_js_1.initSession)(configurationName, (_a = configuration.storage) !== null && _a !== void 0 ? _a : sessionStorage);
                session.setLoginParams(configurationName, { callbackPath: url, extras: originExtras });
                yield session.setNonceAsync(nonce);
                storage = session;
            }
            // @ts-ignore
            const extraInternal = Object.assign({ client_id: configuration.client_id, redirect_uri: redirectUri, scope, response_type: 'code' }, extraFinal);
            yield (0, requests_js_1.performAuthorizationRequestAsync)(storage)(oidcServerConfiguration.authorizationEndpoint, extraInternal);
        }
        catch (exception) {
            publishEvent(events_js_1.eventNames.loginAsync_error, exception);
            throw exception;
        }
    });
    return loginLocalAsync();
};
exports.defaultLoginAsync = defaultLoginAsync;
const loginCallbackAsync = (oidc) => (isSilentSignin = false) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        oidc.publishEvent(events_js_1.eventNames.loginCallbackAsync_begin, {});
        const configuration = oidc.configuration;
        const clientId = configuration.client_id;
        const redirectUri = isSilentSignin ? configuration.silent_redirect_uri : configuration.redirect_uri;
        const authority = configuration.authority;
        const tokenRequestTimeout = configuration.token_request_timeout;
        const oidcServerConfiguration = yield oidc.initAsync(authority, configuration.authority_configuration);
        const queryParams = (0, route_utils_js_1.getParseQueryStringFromLocation)(window.location.href);
        const sessionState = queryParams.session_state;
        const serviceWorker = yield (0, initWorker_js_1.initWorkerAsync)(configuration.service_worker_relative_url, oidc.configurationName);
        let storage;
        let nonceData;
        let getLoginParams;
        let state;
        if (serviceWorker) {
            serviceWorker.startKeepAliveServiceWorker();
            yield serviceWorker.initAsync(oidcServerConfiguration, 'loginCallbackAsync', configuration);
            yield serviceWorker.setSessionStateAsync(sessionState);
            nonceData = yield serviceWorker.getNonceAsync();
            getLoginParams = serviceWorker.getLoginParams(oidc.configurationName);
            state = yield serviceWorker.getStateAsync();
            storage = serviceWorker;
        }
        else {
            const session = (0, initSession_js_1.initSession)(oidc.configurationName, (_a = configuration.storage) !== null && _a !== void 0 ? _a : sessionStorage);
            yield session.setSessionStateAsync(sessionState);
            nonceData = yield session.getNonceAsync();
            getLoginParams = session.getLoginParams(oidc.configurationName);
            state = yield session.getStateAsync();
            storage = session;
        }
        const params = (0, route_utils_js_1.getParseQueryStringFromLocation)(window.location.toString());
        if (params.iss && params.iss !== oidcServerConfiguration.issuer) {
            throw new Error('issuer not valid');
        }
        if (params.state && params.state !== state) {
            throw new Error('state not valid');
        }
        const data = {
            code: params.code,
            grant_type: 'authorization_code',
            client_id: configuration.client_id,
            redirect_uri: redirectUri,
        };
        const extras = {};
        // @ts-ignore
        if (configuration.token_request_extras) {
            for (const [key, value] of Object.entries(configuration.token_request_extras)) {
                extras[key] = value;
            }
        }
        if (getLoginParams && getLoginParams.extras) {
            for (const [key, value] of Object.entries(getLoginParams.extras)) {
                if (key.endsWith(':token_request')) {
                    extras[key.replace(':token_request', '')] = value;
                }
            }
        }
        const tokenResponse = yield (0, requests_js_1.performFirstTokenRequestAsync)(storage)(oidcServerConfiguration.tokenEndpoint, Object.assign(Object.assign({}, data), extras), oidc.configuration.token_renew_mode, tokenRequestTimeout);
        if (!tokenResponse.success) {
            throw new Error('Token request failed');
        }
        let loginParams;
        const formattedTokens = tokenResponse.data.tokens;
        if (serviceWorker) {
            yield serviceWorker.initAsync(redirectUri, 'syncTokensAsync', configuration);
            loginParams = serviceWorker.getLoginParams(oidc.configurationName);
        }
        else {
            const session = (0, initSession_js_1.initSession)(oidc.configurationName, configuration.storage);
            loginParams = session.getLoginParams(oidc.configurationName);
        }
        // @ts-ignore
        if (tokenResponse.data.state !== extras.state) {
            throw new Error('state is not valid');
        }
        const { isValid, reason } = (0, parseTokens_js_1.isTokensOidcValid)(formattedTokens, nonceData.nonce, oidcServerConfiguration);
        if (!isValid) {
            throw new Error(`Tokens are not OpenID valid, reason: ${reason}`);
        }
        yield oidc.startCheckSessionAsync(oidcServerConfiguration.checkSessionIframe, clientId, sessionState, isSilentSignin);
        oidc.publishEvent(events_js_1.eventNames.loginCallbackAsync_end, {});
        return {
            tokens: formattedTokens,
            state: 'request.state',
            callbackPath: loginParams.callbackPath,
        };
    }
    catch (exception) {
        console.error(exception);
        oidc.publishEvent(events_js_1.eventNames.loginCallbackAsync_error, exception);
        throw exception;
    }
});
exports.loginCallbackAsync = loginCallbackAsync;
//# sourceMappingURL=login.js.map